let csvw_url = 'https://www.csvw.com';


let workspace60 = [];
let workspace60big = [];
for (let i = 0; i < 6; i++) {
  let arr = [];
  if (i!=4){
    for (let j = 0; j < 5; j++) {
      let element = require(`../../assets/exhibition-sh/imgs/3/${i+1}-${j+1}.jpg`);
      arr.push(element);
      let elementbig = require(`../../assets/exhibition-sh/imgs/3/big/${i+1}-${j+1}.jpg`);
      workspace60big.push(elementbig);
    }
    workspace60.push(arr);
  }
}

let workspace61 = [];
let workspace61big = [];
for (let i = 0; i < 12; i++) {
  let arr = [];
  for (let j = 0; j < 5; j++) {
    let element = require(`../../assets/exhibition-sh/imgs/5/${i+1}-${j+1}.jpg`);
    arr.push(element);
    let elementbig = require(`../../assets/exhibition-sh/imgs/5/big/${i+1}-${j+1}.jpg`);
    workspace61big.push(elementbig);
  }
  workspace61.push(arr);
}

export default {
  // 列表
  workspace4: [{
      title: '新品牌、新产品、新模式 上汽大众携三大品牌亮相2021上海车展',
      content: '4月19日，2021上海车展如约开幕，上汽大众携三大品牌共同亮相国家会展中心（上海）5.1号馆与3号馆，以新品牌、新产品、新模式，为消费者带来缤纷看点。',
      imgurl: require("../../assets/exhibition-sh/imgs/tu1@2x.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu1-m@2x.png"),
      url: 'https://www.csvw.com/csvw-website/news/company-news.html?newsid=3012'
    },
    {
      title: '新车投放提速 上汽大众ID.6 X、全新途昂家族联袂亮相上海车展',
      content: '',
      imgurl: require("../../assets/exhibition-sh/imgs/tu2@2x.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu2-m@2x.png"),
      url: 'https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=3007'
    },
    {
      title: '驾驭时代，承启未来，上汽奥迪携旗舰车型闪耀亮相2021上海车展',
      content: '',
      imgurl: require("../../assets/exhibition-sh/imgs/tu3@2x.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu3-m@2x.png"),
      url: 'https://www.csvw.com/csvw-website/news/company-news.html?newsid=3005'
    },
    {
      title: '全新明锐PRO公众首秀  斯柯达携焕新阵容出击2021上海车展',
      content: '',
      imgurl: require("../../assets/exhibition-sh/imgs/tu4@2x.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu4-m@2x.png"),
      url: 'https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=3004'
    }
  ],
  // 亮点车型
  workspace5: [{
      title: 'ID.6 X',
      content: 'ID.6 X是一款打造品质标杆的七座智能纯电SUV，ID.6 X秉持大众品牌电动车家族的设计语言，是上汽大众电动SUV家族的领航者。',
      imgurl: require("../../assets/exhibition-sh/imgs/tu5@2x.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      videourl: csvw_url + "/u/cms/www/202104/27153247ydRT.mp4",
      url: 'https://www.csvw.com/svwmedia-website/media/teramont.html?contentId=24967'
    },
    {
      title: 'All New Teramont 全新途昂',
      content: 'All New Teramont全新途昂是上汽大众旗舰全尺寸七座SUV，它不仅丰富了上汽大众在SUV细分市场的产品阵容，还与PHIDEON辉昂、Viloran威然一同构建起上汽大众高端产品阵营。',
      imgurl: require("../../assets/exhibition-sh/imgs/tu6@2x.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu6-m@2x.png"),
      videourl: csvw_url + "/u/cms/www/202104/261457040660.mp4",
      url: 'https://www.csvw.com/svwmedia-website/activities/detail.html?contentId=24988'
    },
    {
      title: 'All New Teramont X 全新途昂X',
      content: '大众品牌旗舰豪华运动SUV全新途昂X以新造型旗舰设计、大格局数字空间、强安全行车科技、超智能交互科技、全路况操控性能，开拓全新的SUV细分市场。',
      imgurl: require("../../assets/exhibition-sh/imgs/tu7@2x.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu7-m@2x.png"),
      videourl: csvw_url + "/u/cms/www/202104/26145737R036.mp4",
      url: 'https://www.csvw.com/svwmedia-website/activities/detail.html?contentId=24989'
    },
    {
      title: 'All New Audi A7L 全新奥迪A7L',
      content: '2021年4月18日，上汽奥迪带来了首款C+级性能行政车型——全新奥迪A7L的全球首秀。承袭了奥迪品牌的经典基因和领先技术，全新奥迪A7L将运动性与舒适性完美结合，既能够满足精英人士对商务格调的品味要求，又紧密贴合了新世代凌厉动感的审美趋势。',
      imgurl: require("../../assets/exhibition-sh/imgs/tu8@2x.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu8-m@2x.png"),
      videourl: csvw_url + "/u/cms/www/202104/26145739K8ue.mp4",
      url: 'https://saic-audi.audibrand.cn/zh/models/a/all_new_a7l.html'
    },
    {
      title: 'OCTAVIA PRO 全新明锐PRO',
      content: '全新明锐PRO，是首款采用全新MQB EVO数字智能架构的斯柯达车型，依托全方位领先的八大PRO亮点以及诚意满满的价格，全力出击A+级轿车市场。',
      imgurl: require("../../assets/exhibition-sh/imgs/tu9@2x.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu9-m@2x.png"),
      videourl: csvw_url + "/u/cms/www/202104/26145739437C.mp4",
      url: 'https://www.csvw.com/svwmedia-website/media/teramont.html?contentId=24936'
    }
  ],
  // 现场花絮
  workspace6: [{
      title: '3号馆',
      key: 'workspace60'
    },
    {
      title: '5.1号馆',
      key: 'workspace61'
    }
  ],
  workspace60: workspace60,
  workspace60big: workspace60big,
  workspace61: workspace61,
  workspace61big: workspace61big,
  // 新车赏析
  workspace7: [{
      title: 'ID.6 X',
      key: 'workspace70'
    },
    {
      title: '全新途昂',
      key: 'workspace71'
    },
    {
      title: '全新途昂X',
      key: 'workspace72'
    },
    {
      title: '全新奥迪A7L',
      key: 'workspace73'
    },
    {
      title: '全新明锐PRO',
      key: 'workspace74'
    }
  ],

  // 新车赏析0
  workspace70: [{
      title: '网上车市',
      content: 'ID.6 X最大功率为150kW，峰值扭矩为310Nm，动力性能强劲、高效。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/1.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://chejiahao.autohome.com.cn/info/8441528'
    },
    {
      title: '汽场汽车',
      content: 'ID.6 X整车造型的型面饱满有力，线条动感流畅，创新感性的设计元素在匹配电动汽车独有气质的同时，将数字、科技、未来的感觉表现得淋漓尽致。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/2.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://auto.ifeng.com/c/85j0jfZWGqO'
    },
    {
      title: '易车',
      content: 'ID.6 X不仅支持手机远程控制车辆，车主还可以使用智能手表控制车内空调、车辆解锁等功能。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/3.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://news.yiche.com/hao/wenzhang/45574499/'
    },
    {
      title: '水滴汽车',
      content: 'ID.6 X仪表、中央触控、AR-HUD增强现实抬头显示组成的三屏交互架构摒弃了堆砌功能按键的传统交互思路，更具科技感和便利性。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/4.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://baijiahao.baidu.com/s?id=1697630227732780739&wfr=spider&for=pc'
    },
    {
      title: '车业杂谈',
      content: 'ID.6 X贯穿式尾灯是尾部一大亮点，纤细灯带与两侧3D LED灯组自然的衔接，拉宽了尾部视觉宽度。全新扁平化发光LOGO装配在中间，简约纯粹又颇具科技感。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/5.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.dongchedi.com/article/6955439282786320904'
    },
    {
      title: '选车网',
      content: 'ID.6 X灯腔内的矩阵LED大灯富有三维变化，车灯整体造型体量感十足，轮廓延伸至车身两侧，与醒目的IQ Light标识相融合，营造出一种蓄势待发的神情。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/6.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://www.chooseauto.com.cn/xinche/guonei/311659.shtml'
    },
    {
      title: '买车网',
      content: 'ID.6 X的多层结构电池包采用4重电芯安全设计，并经过338项电池包安全测试，保障电池包在各种极端工况下的安全。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/7.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://chejiahao.autohome.com.cn/info/8439479'
    },
    {
      title: '汽车消费网',
      content: 'ID.6 X搭载的IQ. Drive L2级驾驶辅助，支持方向盘脱手检测及带Stop & Go自动跟车启停，行车更加智能、安全。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/8.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://inf.315che.com/n/2021_04/2022962/'
    },
    {
      title: '中国网汽车',
      content: 'ID.6 X 30色内饰氛围灯可以无级调节，多层布置让整车氛围更加高级。ID. Light 光语系统还会伴随操作指令进行交互闪烁。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/9.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://m.gxfin.com/article/auto/default/default/2021-04-25/712193.html'
    },
    {
      title: '华龙汽车',
      content: 'ID.6 X搭载了上汽大众最新一代智慧车联系统，结合上汽大众超级APP，让车主畅享包含智慧导航、智联控车、智享娱乐、智能家居、智能音箱等一系列在线服务。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/10.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://car.cqnews.net/html/2021-04/19/content_51316356.html'
    },
    {
      title: '汽车焦点',
      content: 'ID.6 X贯通式仪表台设计与多处悬浮式设计的应用，视觉上拉宽内饰空间效果的同时，层次感也更加丰富。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/11.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://www.mycar58.com/xinche/31642.html'
    },
    {
      title: '侃车e族',
      content: 'ID.6 X车长4876mm、宽1848mm、高1680mm，轴距长达2965mm，提供6座/7座选择，空间阔绰，布局灵活。',
      imgurl: require("../../assets/exhibition-sh/imgs/70/12.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.maiche.com/news/detail/2409062.html'
    },
    // {
    //   title: '功夫汽车',
    //   content: 'ID.6 X的全视野景观天幕和可开启全景天窗为驾乘人员在视觉上提供了通透的景观空间。',
    //   imgurl: require("../../assets/exhibition-sh/imgs/70/13.png"),
    //   imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
    //   url: 'http://www.gongfuauto.cn/a/6183.html'
    // },
  ],

  // 新车赏析1
  workspace71: [{
      title: '汽车之家',
      content: '全新途昂提供第三代EA888 2.0T低碳版/高功版涡轮增压发动机与DQ501 DSG 7速湿式双离合变速器的黄金动力组合，带来澎湃动力性能。',
      imgurl: require("../../assets/exhibition-sh/imgs/71/1.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.autohome.com.cn/advice/202104/1140541.html#p1'
    },
    {
      title: '华龙汽车',
      content: '全新途昂搭载智慧车联系统，带来更加高效、数字化的驾乘新体验。',
      imgurl: require("../../assets/exhibition-sh/imgs/71/2.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://car.cqnews.net/html/2021-04/19/content_51316356.html'
    },
    {
      title: '头号汽车',
      content: '全新途昂IQ.Light尊贵迎宾仪式，在靠近/远离车辆时，大灯与尾灯会有迎宾唤醒光效或离车休眠光效的动态效果。',
      imgurl: require("../../assets/exhibition-sh/imgs/71/3.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://www.touhao8.com/index?article_id=1842'
    },
    {
      title: '车生活',
      content: '全新途昂采用悬浮式中控交互屏设计，辅以双层中央控制台及可调式氛围灯及环绕饰板，打造立体悬浮科技氛围。',
      imgurl: require("../../assets/exhibition-sh/imgs/71/4.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.cheshenghuo.com/news/17438.html'
    },
    {
      title: '侃车e族',
      content: '全新途昂运用横贯式发光前格柵与LOGO，硬核SUV的气势磅礴基调即刻展现。',
      imgurl: require("../../assets/exhibition-sh/imgs/71/5.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://news.yiche.com/hao/wenzhang/45573037/'
    },
    {
      title: '车一圈',
      content: '全新途昂配备了智能四驱系统、全路况多重驾驶模式选择，能够轻松应对各种复杂路况。',
      imgurl: require("../../assets/exhibition-sh/imgs/71/6.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.toutiao.com/i6952853710250836516/?tt_from=weixin&utm_campaign=client_share&wxshare_count=1&timestamp=1618927517&app=news_article&utm_source=weixin&utm_medium=toutiao_ios&use_new_style=1&req_id=202104202205170101351550314A034EB0&share_token=A8DA7B71-7ED3-4126-A16C-F9CA706ED49C&group_id=6952853710250836516'
    },
    {
      title: '白日梦车',
      content: '全新途昂有30色环境氛围灯豪华套装、哈曼卡顿高级音响，搭配12英寸智能多媒体交互系统，豪华的科技氛围无处不在。',
      imgurl: require("../../assets/exhibition-sh/imgs/71/7.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.toutiao.com/i6953163552446349863/'
    },
    // {
    //   title: '功夫汽车',
    //   content: '全新途昂全新应用的IQ.Light全LED矩阵式前大灯通过采集实时车速和雨刮信号来自动调整大灯照射的光型，智能实现多种照明模式。',
    //   imgurl: require("../../assets/exhibition-sh/imgs/71/8.png"),
    //   imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
    //   url: 'http://www.gongfuauto.cn/a/6183.html'
    // }
  ],
  workspace72: [{
      title: '云堆汽车',
      content: '全新途昂X运用了R-Line套件，内嵌高光黑装饰的R-Line特殊前保险杠，搭配底部贯穿两侧的镀铬饰条，进一步强调了横向的视觉感受，也让前脸更具气吞山河的霸气。',
      imgurl: require("../../assets/exhibition-sh/imgs/72/2.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.qctt.cn/news/979980'
    },
    {
      title: '一号汽车网',
      content: '全新途昂X的横向进气格栅与两侧大灯视觉上连为一体，秉承家族化特征，新车气势磅礴基调即刻展现。',
      imgurl: require("../../assets/exhibition-sh/imgs/72/3.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://www.yidianzixun.com/article/0TtVZZ4Q'
    },
    {
      title: '有点车事',
      content: '全新途昂X采用全新一代上汽大众智慧车联系统、多元操作方式，带来清晰、顺畅的智能出行体验。',
      imgurl: require("../../assets/exhibition-sh/imgs/72/4.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.toutiao.com/w/i1697527122248707/'
    },
    {
      title: '座驾参谋',
      content: '全新途昂X 10.2英寸全液晶数字仪表、12英寸多点触控液晶中控屏组成的三位一体的虚拟显示系统，集成更多功能，让车辆信息清晰可读，增添驾驶舱的科幻感。',
      imgurl: require("../../assets/exhibition-sh/imgs/72/5.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://news.yiche.com/hao/wenzhang/45611785/'
    },
    {
      title: '车生活',
      content: '全新途昂X R-Line特殊后保险杠带高光下扰流板及中块反射片的设计非常有新意，让原本宽厚强健的尾部多了几分动感时尚气息。',
      imgurl: require("../../assets/exhibition-sh/imgs/72/6.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.cheshenghuo.com/news/17439.html'
    },
    {
      title: '有车CLUB',
      content: '全新途昂X搭载大众的型号为EA888的2.0T高/低功率发动机，其中330TSI车型发动机最大功率186马力，峰值扭矩320牛·米；380TSI车型发动机最大功率为220马力，峰值扭矩350牛·米。',
      imgurl: require("../../assets/exhibition-sh/imgs/72/7.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://cj.sina.com.cn/articles/view/6301469426/17798caf200100xuts'
    },
    {
      title: '汽车消费网',
      content: '全新途昂X的21寸黑色轮毂搭配红色刹车卡钳，给人强烈的视觉冲击，强化了整车的运动感。',
      imgurl: require("../../assets/exhibition-sh/imgs/72/8.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://inf.m.315che.com/n/2021_04/2022797/'
    },
  ],
  workspace73: [{
      title: '汽车之家',
      content: '全新奥迪A7L配置 48V 轻混系统，全面电气化加持，制动时提供能量回收并用于加速，动力更强劲、乘坐更舒适。',
      imgurl: require("../../assets/exhibition-sh/imgs/73/1.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://chejiahao.autohome.com.cn/info/8465556#pvareaid=6826274'
    },
    {
      title: '车界微视',
      content: '全新奥迪A7L通过奥迪专属个性化账号，上车后即可自动将电动方向盘、电动座椅和外后视镜等调整到预设角度。',
      imgurl: require("../../assets/exhibition-sh/imgs/73/2.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.toutiao.com/i6952870976073826824/?tt_from=weixin&utm_campaign=client_share&wxshare_count=1&timestamp=1618843076&app=news_article&utm_source=weixin&utm_medium=toutiao_ios&use_new_style=1&req_id=202104192237560101512042173E1294DE&share_token=D815BDD5-2F17-4633-8DC5-435A2DE5AB77&group_id=6952870976073826824'
    },
    {
      title: '白日梦车',
      content: '全新奥迪A7L行驶中可根据车速、驾驶模式、路况，自动调节车身高度，向下达10mm，向上达20mm，哪怕前路多变，亦稳稳通过。',
      imgurl: require("../../assets/exhibition-sh/imgs/73/3.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://news.yiche.com/hao/wenzhang/45554898/'
    },
    {
      title: '玩车教授',
      content: '全新奥迪A7L向奥迪历史经典车型 Ur-quattro 致敬，13个 LED 垂直光段组成尾部纤细光带，传承奥迪顶级车型共有的风格魅力。',
      imgurl: require("../../assets/exhibition-sh/imgs/73/4.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://baijiahao.baidu.com/s?id=1698294878175314102&wfr=spider&for=pc'
    },
    {
      title: '头号汽车',
      content: '全新奥迪A7L彩色的车辆信息、道路标识、导航信息，都直观清晰地显示在正前方，驾驶员目光可始终专注于前方路面，行车更安全。',
      imgurl: require("../../assets/exhibition-sh/imgs/73/5.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://www.touhao8.com/index?article_id=1823'
    },
    {
      title: '座驾参谋',
      content: '全新奥迪A7L带 5G 高速传输通信模块的智慧城市互联技术，可实现 V2V、V2N 通信，实现多项安全预警及绿波车速引导。',
      imgurl: require("../../assets/exhibition-sh/imgs/73/6.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://chejiahao.autohome.com.cn/info/8395409?r=20210419154909'
    },
    // {
    //   title: '功夫汽车',
    //   content: '全新奥迪A7L 12.3英寸高分辨率 TFT 屏幕，位于驾驶员视线正前方，多项驾驶信息，排列简单易懂、一目了然。',
    //   imgurl: require("../../assets/exhibition-sh/imgs/73/7.png"),
    //   imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
    //   url: 'http://www.gongfuauto.cn/a/6181.html'
    // },
    {
      title: '云堆汽车',
      content: '全新奥迪A7L下车后，在人车距离6米内，长按手机 APP 泊车键，即可实现垂直车位的自动泊出、泊入和转向功能。',
      imgurl: require("../../assets/exhibition-sh/imgs/73/8.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.qctt.cn/news/979969'
    },
    {
      title: '穹眼财经',
      content: '全新奥迪A7L四个摄像头，全方位显示车辆四周全景图，配合中央驾驶辅助控制系统，持续计算周围环境图像。',
      imgurl: require("../../assets/exhibition-sh/imgs/73/9.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://m.sohu.com/a/462371908_329297/?pvid=000115_3w_a'
    },
    {
      title: '球叔教你买车',
      content: '全新奥迪A7L 5076mm的车身长度和3026mm的长轴距，优雅灵动的线条和低趴车身姿态，实现了乘坐空间、造型美感的完美融合。',
      imgurl: require("../../assets/exhibition-sh/imgs/73/10.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://news.yiche.com/hao/wenzhang/45521949/'
    },
    {
      title: 'EV世纪-EV君',
      content: '全新奥迪A7L无框车门保留了轿跑的设计元素，经典又充满运动感。配置电吸门功能，车门半锁即可正常工作。',
      imgurl: require("../../assets/exhibition-sh/imgs/73/11.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://www.21cnev.com/html/202104/787743_1.html'
    },
    // {
    //   title: 'Report汽车',
    //   content: '全新奥迪A7L Bang&Olufsen 3D 环绕沉浸式音响系统，拥有16个扬声器，包括高音及中置扬声器与低音炮，无论坐在哪一排，都如置身音乐会前排。',
    //   imgurl: require("../../assets/exhibition-sh/imgs/73/12.png"),
    //   imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
    //   // url: 'http://www.reportauto.cn/f/view-28-3114.html'
    // },
  ],
  workspace74: [{
      title: '汽车之家',
      content: '全新明锐PRO全系标配1.4TSI高功率发动机、最大扭矩250N.m，兼具澎湃的动力体验与优秀的燃油经济性。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/1.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.autohome.com.cn/news/202104/1145407.html#pvareaid=2023650'
    },
    {
      title: '网上车市',
      content: '全新明锐PRO配备了同级罕有的电子排挡，不仅操作便捷，也更加节省空间。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/2.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://chejiahao.autohome.com.cn/info/8482131#pvareaid=6826274'
    },
    {
      title: '易车',
      content: '全新明锐PRO的T型中控台布局整齐有序，悬浮式中控屏和“911同款”的电子挡杆大大提升了科技感。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/3.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://news.yiche.com/xinchexiaoxi/20210428/2114449083.html'
    },
    {
      title: '水滴汽车',
      content: '全新明锐PRO现代化的智能辅助驾驶设备，比如毫米波雷达探头和前视摄像头，都将隐藏在斯柯达品牌经典的格栅之内。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/4.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://chejiahao.autohome.com.cn/info/8478117#pvareaid=6826274'
    },
    {
      title: '白日梦车',
      content: '全新明锐PRO采用全新MQB EVO数字智能架构，全车15个超声波、毫米波雷达，以及5个摄像头，打造全新升级的德系数字科技体验。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/5.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://aikahao.xcar.com.cn/item/772451.html'
    },
    {
      title: '华龙汽车',
      content: '全新明锐PRO全面升级，4753mm/1832mm/1469mm的长宽高（含外饰件），以及2730mm的车身轴距。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/6.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://car.cqnews.net/html/2021-04/19/content_51316393.html'
    },
    {
      title: '头号汽车网',
      content: '全新明锐PRO实现了集按键、手势、触控、语音在内的多元操控形式，可以带来更为便捷的交互体验。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/7.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://www.touhao8.com/index?article_id=1843'
    },
    {
      title: '车生活',
      content: '全新明锐PRO搭载斯柯达智慧车联系统的车型，配合斯柯达超级APP，拥有智能语音、智慧导航、智享娱乐、智趣出行、智联控车5大核心功能。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/8.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.cheshenghuo.com/news/17436.html'
    },
    {
      title: '汽车葫芦圈',
      content: '全新明锐PRO内饰材质上选择众多软性包覆材质，在中控区和门板处均采用软性皮质材料及同色缝线，中控区更是使用带有碳纤维纹理的Carbon材质包覆，内饰质感大幅提升。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/9.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.toutiao.com/i6953517766104236576'
    },
    {
      title: '汽车焦点',
      content: '全新明锐PRO很巧妙地将掀背、溜背结合起来，与水晶设计架构的元素形成共振，营造出了不逊于“轿跑家用车”的运动范儿。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/10.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://www.mycar58.com/xinche/31793.html'
    },
    // {
    //   title: '功夫汽车',
    //   content: '全新明锐PRO全新设计的立体垂瀑式格栅造型年轻犀利，发动机盖上的立体棱线营造出三维立体雕塑感。',
    //   imgurl: require("../../assets/exhibition-sh/imgs/74/11.png"),
    //   imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
    //   url: 'http://www.gongfuauto.cn/a/6182.html'
    // },
    {
      title: '中国经济新闻网',
      content: '全新明锐PRO采用了大掀背设计，不仅后备厢容积表现出色，其后排乘坐空间并没有丝毫“缩水”。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/12.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'http://www.cet.com.cn/wzsy/ycxw/2829297.shtml'
    },
    {
      title: '阿贵看车',
      content: '全新明锐PRO全系标配全新升级的后独立悬挂，该悬挂采用四连杆结构，可分解横向和纵向受力，带来更好的操控体验。',
      imgurl: require("../../assets/exhibition-sh/imgs/74/13.png"),
      imgurlMobile: require("../../assets/exhibition-sh/imgsMobile/tu5-m@2x.png"),
      url: 'https://www.toutiao.com/i6953250474166551051/'
    },
  ],
}
